export const FORM_MODES = Object.freeze({
  CREATE: "CREATE",
  UPDATE: "UPDATE",
});
